export const getIsMobile = () => window.innerWidth <= 900;